import { useState } from 'react';

export function useQuoteCardDialogs() {
  const [showJointPolicyDeleteDialog, setShowJointPolicyDeleteDialog] = useState(false);
  const [jointPolicyDeleteMode, setJointPolicyDeleteMode] = useState<'both' | 'client-only'>(
    'both',
  );
  const [showQuoteGenerationInfoDialog, setShowQuoteGenerationInfoDialog] = useState(false);

  const handleJointPolicyDeleteCancel = () => {
    setShowJointPolicyDeleteDialog(false);
    setJointPolicyDeleteMode('both');
  };

  const handleJointPolicyDeleteConfirm = (
    mode: 'both' | 'client-only',
    deletePolicyForBothClients: () => void,
    deletePolicyForClientOnly: () => void,
  ) => {
    if (mode === 'both') {
      deletePolicyForBothClients();
    } else {
      deletePolicyForClientOnly();
    }
    setShowJointPolicyDeleteDialog(false);
    setJointPolicyDeleteMode('both');
  };

  const showJointDialog = () => setShowJointPolicyDeleteDialog(true);
  const showQuoteGenerationInfoDialogFn = () => setShowQuoteGenerationInfoDialog(true);
  const hideQuoteGenerationInfoDialog = () => setShowQuoteGenerationInfoDialog(false);

  return {
    showJointPolicyDeleteDialog,
    jointPolicyDeleteMode,
    showQuoteGenerationInfoDialog,
    setJointPolicyDeleteMode,
    handleJointPolicyDeleteCancel,
    handleJointPolicyDeleteConfirm,
    showJointDialog,
    showQuoteGenerationInfoDialogFn,
    hideQuoteGenerationInfoDialog,
  };
}
